import { Box } from '@mui/material';
import { useSearchParams } from 'react-router';

import type { ToggleViewType } from '@/apps/engagement-letter-database/data/types';

import DashboardViewToggle from './components/LetterTypeToggle';
import PageHeader from './components/PageHeader';

const HeaderPane = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isWaiver = searchParams.get('letterType') === 'waiver';
  const viewType: ToggleViewType =
    searchParams.get('engagementLetterView') === 'clients' ? 'clients' : 'related-clients';
  const handleLetterTypeChange = (value: ToggleViewType) => {
    setSearchParams((prev) => {
      if (value === 'related-clients') {
        prev.delete('engagementLetterView');
      } else {
        prev.set('engagementLetterView', value);
      }
      return prev;
    });
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 3,
          justifyContent: 'space-between',
        }}
      >
        <PageHeader value={isWaiver ? 'waiver' : viewType} />
      </Box>

      {!isWaiver && <DashboardViewToggle value={viewType} onChange={handleLetterTypeChange} />}
    </>
  );
};

export default HeaderPane;
